import * as actions from './actions';
import * as getters from './getters';

import {
  SET_UPSELL_OVERLAY,
  SET_UPSELL_PRICING_MODEL,
  SET_UPSELL_PRODUCT_TYPE,
  SET_UPSELL_SEQUENCE_SNAPSHOT,
  SET_UPSELL_TOUR_ID,
} from '../mutation-types';

const mutations = {
  [SET_UPSELL_PRODUCT_TYPE](state, payload) {
    state.productType = payload;
  },
  [SET_UPSELL_PRICING_MODEL](state, payload) {
    state.pricingModel = payload;
  },
  [SET_UPSELL_TOUR_ID](state, payload) {
    state.tourId = payload;
  },
  [SET_UPSELL_SEQUENCE_SNAPSHOT](state, payload) {
    state.snapshot = payload;
  },
  [SET_UPSELL_OVERLAY](state, payload) {
    state.overlay = payload;
  },
};

const state = () => ({
  productType: null,
  pricingModel: null,
  tourId: null,
  snapshot: null,
  overlay: null,
});

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
